import React from "react";

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "ยืนยัน",
  cancelText = "ยกเลิก",
  type = "default",
}) => {
  if (!isOpen) return null;

  const getTypeStyles = () => {
    switch (type) {
      case "danger":
        return {
          confirmButtonClass: "btn btn-error",
          iconColor: "#ef4444",
          icon: "⚠️",
        };
      case "warning":
        return {
          confirmButtonClass: "btn btn-warning",
          iconColor: "#f59e0b",
          icon: "⚠️",
        };
      default:
        return {
          confirmButtonClass: "btn btn-primary",
          iconColor: "#6366f1",
          icon: "❓",
        };
    }
  };

  const typeStyles = getTypeStyles();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal"
        style={{ maxWidth: "400px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "24px", color: typeStyles.iconColor }}>
              {typeStyles.icon}
            </span>
            <h2 style={{ fontSize: "18px", fontWeight: "600", margin: 0 }}>
              {title}
            </h2>
          </div>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="modal-body">
          <p style={{ margin: 0, lineHeight: "1.5", whiteSpace: "pre-line" }}>
            {message}
          </p>
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            {cancelText}
          </button>
          <button className={typeStyles.confirmButtonClass} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
